import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { Eyebrow, Reveal } from "../components/Reveal";
import { BriefForm } from "../brief/BriefForm";
import { scrollToId } from "../lib/scroll";

const MONDAY_URL = process.env.REACT_APP_MONDAY_WORKFORM_EMBED_URL;

export default function ClientIntelligenceBrief() {
  const { hash } = useLocation();

  useEffect(() => {
    document.title = "Client Intelligence Brief — ENEXUR India Market Intelligence™";
  }, []);

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 80);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <main className="min-h-screen">
      <Nav />

      <header className="border-b border-gold/15 pt-[76px]">
        <div className="wrap pb-16 pt-16 md:pb-20 md:pt-24">
          <Link
            to="/india-market-intelligence"
            data-testid="brief-return-link"
            className="inline-flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.24em] text-mist transition-colors hover:text-gold"
          >
            <ArrowLeft size={13} aria-hidden="true" />
            Return to the product page
          </Link>
          <Reveal className="mt-12">
            <Eyebrow>ENEXUR India Market Intelligence™</Eyebrow>
            <h1 className="mt-8 max-w-3xl font-display text-4xl leading-[1.08] text-ivory md:text-6xl">
              Client Intelligence <em className="font-light text-gold-soft">Brief</em>
            </h1>
            <p className="mt-7 max-w-2xl text-[17px] leading-relaxed text-mist">
              Seven short sections. Your answers tell us where you stand — and
              where you want to go — and shape a private, bespoke engagement
              proposal.
            </p>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.28em] text-gold/80">
              Confidential • 7 sections • No obligation
            </p>
          </Reveal>
        </div>
      </header>

      <section className="py-16 md:py-24">
        <div className="wrap">
          {MONDAY_URL ? (
            <iframe
              src={MONDAY_URL}
              title="Client Intelligence Brief — Monday WorkForm"
              className="h-[1400px] w-full border border-gold/20 bg-abyss/50"
              data-testid="monday-workform-embed"
            />
          ) : (
            <BriefForm />
          )}
        </div>
      </section>

      <Footer />
    </main>
  );
}
